/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import { reducerName, createActionName } from './naming';
import * as types from './actionsTypes';
import {
  createValidateObject,
  storeSetFieldValue
} from '../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../utils/reducerHalpers/validateTypes';

const createCommentFormReducer = name => {
  function stateDefault() {
    return {
      fields: {
        activation_code: {
          title: 'Код купона',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }
      },
      resultObject: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, types.SEND_FORM):
        return state;
      case createActionName(name, types.SET_FIELD_ACTIVATION_CODE):
        return storeSetFieldValue(state, 'activation_code', action.payload);
      case createActionName(name, types.SET_RESULT_OBJECT):
        return state.merge({
          resultObject: action.payload
        });
      case createActionName(name, types.INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createCommentFormReducer(parentName);
  return reduceObject;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/coupons/reducers/activatedCouponForm/reducer.js